import { render, staticRenderFns } from "./CrudDeliveryPrices.vue?vue&type=template&id=dfc573ee&scoped=true"
import script from "./CrudDeliveryPrices.vue?vue&type=script&lang=js"
export * from "./CrudDeliveryPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc573ee",
  null
  
)

export default component.exports